import { useTheme } from '@mui/material';

export const PatientChartIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
    } = theme.colors.other.icon;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
        >
            <path
                d="M32 38H16C14.8937 38 14 37.1063 14 36V12C14 10.8937 14.8937 10 16 10H24V17C24 18.6562 25.3438 20 27 20H34V36C34 37.1063 33.1063 38 32 38ZM27 18C26.45 18 26 17.55 26 17V10.0312C26.175 10.075 26.3375 10.1625 26.4625 10.2938L33.7062 17.5375C33.8375 17.6688 33.925 17.825 33.9688 18H27ZM16 8C13.7938 8 12 9.79375 12 12V36C12 38.2062 13.7938 40 16 40H32C34.2062 40 36 38.2062 36 36V18.2437C36 17.45 35.6812 16.6875 35.1187 16.125L27.8813 8.88125C27.3188 8.31875 26.5562 8 25.7625 8H16ZM19 24C18.45 24 18 24.45 18 25C18 25.55 18.45 26 19 26H29C29.55 26 30 25.55 30 25C30 24.45 29.55 24 29 24H19ZM19 28C18.45 28 18 28.45 18 29C18 29.55 18.45 30 19 30H29C29.55 30 30 29.55 30 29C30 28.45 29.55 28 29 28H19ZM19 32C18.45 32 18 32.45 18 33C18 33.55 18.45 34 19 34H29C29.55 34 30 33.55 30 33C30 32.45 29.55 32 29 32H19Z"
                fill={primaryStroke}
            />
        </svg>
    );
};
